import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class DefectHistoryConstants {
    //general
    title = "Defect History";
    dateRangeDialogTitle = "Select Date Range";
    proceedButtonText = "Proceed";
    cancelButtonText = "Cancel";
    cqmsBreadCrumbText = "CQMS /";
    defectHistoryBreadCrumbText = "Defect History";
}